import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import { connect } from "react-redux";
import Header from "./Header";
import Footer from "./Footer";
import ImpersonationBanner from "../../../components/ImpersonationBanner/ImpersonationBanner";
import "./adminAppShell.scss";
import "./adminPage.scss";

/**
 * Persistent shell for all authenticated private routes.
 * Header + sidebar stay mounted while only page content swaps (Outlet).
 */
const PrivateLayoutShell = ({ SectionClass }) => (
  <Fragment>
    <div className="private-app-shell">
      <ImpersonationBanner />
      <Header />
      <section className={SectionClass || "contentboxcont"}>
        <div className="admin-page-content">
          <Outlet />
        </div>
      </section>
      <Footer />
    </div>
  </Fragment>
);

const mapStateToProps = (state) => ({
  SectionClass: state.layout.sectionClass,
});

export default connect(mapStateToProps, null)(PrivateLayoutShell);
